define(function () {

    var ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' + '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF';
    var rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
    var rtlRgx = new RegExp('^[^' + rtlChars + ']*[' + ltrChars + ']');
    var ltrRgx = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']');

    var DIRECTION_LTR = {key: '1', value: 'ltr'};
    var DIRECTION_RTL = {key: '2', value: 'rtl'};

    /**
     * return an object with the direction detection result
     * DIRECTION_LTR: key = '1', value = 'ltr'
     * DIRECTION_RTL: key = '2', value = 'rtl'
     */
    var detectTextDirection = function (str, baseDirection) {
        var targetDirection = baseDirection || DIRECTION_LTR.key;

        if (targetDirection === DIRECTION_LTR.key) {
            return !ltrRgx.test(str) ? DIRECTION_LTR : DIRECTION_RTL;
        } else {
            return !rtlRgx.test(str) ? DIRECTION_RTL : DIRECTION_LTR;
        }
    };

    return {
        detectTextDirection:detectTextDirection
    };
});
